import { useMemo } from "react";
import { usePaginatedReactions } from "@/hooks/usePaginatedReactions";
import { reactionsApi } from "@/lib/humhub-api/reactions";
import type { ReactionType } from "@/lib/humhub-api/types";

export const COMMENT_REACTION_OBJECT_MODEL =
  "humhub\\modules\\comment\\models\\Comment";

interface UseCommentReactionsOptions {
  objectId?: number | string | null;
  enabled?: boolean;
  objectModel?: string;
  perPage?: number;
  emotion?: ReactionType;
}

export const useCommentReactions = ({
  objectId,
  enabled = true,
  objectModel = COMMENT_REACTION_OBJECT_MODEL,
  perPage = 100,
  emotion,
}: UseCommentReactionsOptions) => {
  const queryKey = useMemo(
    () =>
      ["commentReactions", objectModel, objectId, perPage, emotion] as const,
    [objectModel, objectId, perPage, emotion],
  );

  const hasTarget = Boolean(objectId);
  return usePaginatedReactions({
    queryKey,
    enabled,
    hasTarget,
    missingTargetError: "Invalid objectId for comment reactions",
    fetchPage: async (page) =>
      await reactionsApi.findByObject(
        objectModel,
        objectId as number | string,
        page,
        perPage,
        emotion,
      ),
  });
};

export default useCommentReactions;
